// extracted by mini-css-extract-plugin
export var typingIndicator = "_ps-0";